import { z } from 'zod';

const envSchema = z.object({
	VITE_API_URL: z
		.string()
		.optional()
		.transform((val) => val?.trim() || '/api'),
	VITE_ENVIRONMENT: z
		.string()
		.optional()
		.transform((val) => {
			const v = val?.trim()?.toLowerCase();
			return v?.startsWith('feature-') ? 'feature' : v;
		})
		.default('development')
		.pipe(
			z.enum([
				'development',
				'feature',
				'integration',
				'staging',
				'uat',
				'preprod',
				'production',
			]),
		),
	VITE_FIREBASE_API_KEY: z.string().optional(),
	VITE_FIREBASE_AUTH_DOMAIN: z.string().optional(),
	VITE_FIREBASE_PROJECT_ID: z.string().optional(),
	VITE_FIREBASE_AUTH_EMULATOR_URL: z.string().optional(),
	VITE_SENTRY_DSN: z.string().optional(),
	// Base URL of the GCP Logs Explorer for the API project, used to build links filtered on a
	// request or mission ID. Links are hidden when unset.
	VITE_GCP_LOGS_URL: z.string().optional(),
	// Agent app origin, when it is not the back-office host without its "backoffice." prefix.
	VITE_AGENT_APP_URL: z.string().optional(),
});

// Keep in sync with vite.config.ts.
const SENTRY_ENVIRONMENTS: string[] = [
	'integration',
	'staging',
	'uat',
	'preprod',
	'production',
];

const parsedEnv = envSchema.parse(import.meta.env);

export const config = {
	apiUrl: parsedEnv.VITE_API_URL,
	environment: parsedEnv.VITE_ENVIRONMENT,
	firebase: {
		apiKey: parsedEnv.VITE_FIREBASE_API_KEY,
		authDomain: parsedEnv.VITE_FIREBASE_AUTH_DOMAIN,
		projectId: parsedEnv.VITE_FIREBASE_PROJECT_ID,
		authEmulatorUrl: parsedEnv.VITE_FIREBASE_AUTH_EMULATOR_URL,
	},
	enableSentry: SENTRY_ENVIRONMENTS.includes(parsedEnv.VITE_ENVIRONMENT),
	sentryDsn: parsedEnv.VITE_SENTRY_DSN,
	agentAppUrl: parsedEnv.VITE_AGENT_APP_URL?.trim() || undefined,
	sentryTracesSampleRate:
		parsedEnv.VITE_ENVIRONMENT === 'production' ? 0.2 : 1.0,
	gcpLogsUrl: parsedEnv.VITE_GCP_LOGS_URL?.trim() || undefined,
};
